import {msg} from "@/i18n/Message.ts";

//outgoing script function
//example call - ../intouch/makeCall.do?t=SEPB4E9B000146A&a=204&p=0737924718

/**
 * @param el - element to attach UI to
 * @param {string} link - url query string describing context
 * @param sourcePhoneInput - input field containing value with phone number
 * @param sourcePhoneText
 */
export function showActionDialog(el, link, sourcePhoneInput, sourcePhoneText)
{
	let phone = "";
	if (sourcePhoneInput !== null) {
		phone = $('#' + sourcePhoneInput).val();
	} else if (sourcePhoneText !== null) {
		phone = sourcePhoneText;
	} else return;

	//search availableProperties - all terminal and address, and SMS account
	$.ajax({
		type: "GET",
		url: "phone_action",
		contentType: "application/json; charset=UTF-8",
		dataType: "json",
		data:{phone:phone, link:link},
		success: function(availableActionArrayObject) {
			if (availableActionArrayObject.length > 0) {
				if (availableActionArrayObject.length === 1) //run action now
				{
					let obj = availableActionArrayObject[0];
					if (obj.action === "CALL") {
						sendAjaxAction(obj.link);
					} else if (obj.action === "STANDARD_CALL") //external Call href
					{
						let hrefStr = "tel:" + obj.link;
						$(location).attr('href', hrefStr);
					} else {
						$(location).attr('href', obj.link);
					}
				} else //view dialog table
				{
					let menuParent = $(el);
					let positionXY = menuParent.offset();
					let dialog = $('<div class="call-dropdown" style="top:' + parseInt(positionXY.top + 18) + 'px;left:' + positionXY.left + 'px;"></div>');
					$.each(availableActionArrayObject, function (i, obj) {
						let rowLink;
						if (obj.action === "CALL") { //makeCall
							rowLink = $('<a class="call-dropdown-row" href="javascript:void(0);"><span>' + msg("call.from", obj.address)+ '</span></a>');
							rowLink.prepend(Icon.fi("call-out"));
							rowLink.on('click', function(e) { e.preventDefault(); sendAjaxAction(obj.link) });
						} else if (obj.action === "STANDARD_CALL") { //external Call href
							rowLink = $('<a class="call-dropdown-row" href="tel:' + obj.link + '"><span>'+msg("call.link")+'</span></a>');
							rowLink.prepend(Icon.fi("call-out"));
						} else if (obj.action === "COPY") { // phone number to clipboard
							rowLink = $('<a class="call-dropdown-row" href="#" onclick="event.preventDefault();crm.copyEa(this, \''+obj.link+'\');"><span>'+msg("clipboard.copy")+'</span></a>');
							rowLink.prepend(Icon.fi("copy"));
						} else { //SMS
							rowLink = $('<a class="call-dropdown-row" href="' + obj.link + '"><span>'+msg("call.sms")+'</span></a>');
							rowLink.prepend(Icon.fi("mobile-messages"));
						}
						dialog.append(rowLink);
					});
					$("body").append(dialog);
				}
			}
		},
		error: function (request, status, error){
			console.log(request.responseText+' - error:'+error.message);
		}
	});
}
window.showActionDialog = showActionDialog;

export function hideActionDialog() {
	const elm:HTMLElement = document.body.querySelector(".call-dropdown");
	if (elm) elm.remove();
}

function sendAjaxAction(link)
{
	hideActionDialog();
	$.ajax({
		url: link,
		type: 'POST',
		success: function (resp) {
			hideActionDialog();
			//alert(resp);
		},
		error: function(e) {
			//alert('Error: '+e);
		}  
	});
}

document.documentElement.addEventListener("click", hideActionDialog);

export function copyEa(link, copiedValue) {
	navigator.clipboard.writeText(copiedValue);
}